import api from '@/api/auth'
import apiAuth from '@/api/realName'
import { utils } from '@/utils/HybridUtils'
import { Toast, Indicator } from '@lib/gant'
import {  Tools } from "@lib/ggj-utils";
export const facePlusTokenKey = 'WA_facePlus_token'
export const facePlusWaterNoKey = 'WA_facePlus_waterNo'
export const recommendIdKey = 'WA_recommendId'
export const recommendSourceKey = 'WA_recommendSource'

export async function gotoFacePlus(authType = 1, waterNo = null, fromPage) {
  const params = {
		bizType: 4
	}
  const res = await apiAuth.facePlusToken(params)
	Indicator.close()
  if (res.data) {
    localStorage.setItem(facePlusTokenKey, res.data.authToken)
    localStorage.setItem(facePlusWaterNoKey, waterNo)
    if (utils.isApp) {
      window.WebViewJavascriptBridge.callHandler(
				'bioAssay',
				{
					verifyToken: res.data.authToken
				},
				r => {
          // success
          Indicator.close()
          if (JSON.parse(r).status == 1) {
            console.log(r, '成功')
            api.facepluscb({
              // verifyData: JSON.parse(r).data.data,
              verifyToken: res.data.authToken
            }).then(res => {
              if (res.status == 1) {
                location.href = `${location.origin}/wholesale-admin/pages/auth/result.html?fromPage=${fromPage}`
              } else {
                // 识别失败
              }
            })
          } else {
            Toast({
              message: '识别失败,请重试',
              duration: 1000
            })
          }
				}
			)
    } else {
      Toast({
        message: '请使用SS有互APP打开完成实名并充值',
        duration: 1000
      })
    }
  } else {
    Indicator.close()
  }
}

// 人脸识别 face++ 用
export async function getFaceAuth(fromPage) {
	const params = {
		bizType: 4
	}
	Indicator.open()
	const res = await apiAuth.facePlusToken(params)
	Indicator.close()

	if (!res.data) return
	const token = res.data.authToken
	localStorage.setItem(facePlusTokenKey, res.data.authToken)

	bioAssayFacePP(token, (appCallbackData) => {
		finishFacePlus(token, appCallbackData, fromPage)
	},fromPage)
}

export function bioAssayFacePP(token, success,fromPage) {
  try {
    window.WebViewJavascriptBridge.callHandler(
      'bioAssay',
      {
        verifyToken:token
      },
      res => {
        res = JSON.parse(res) || {}
        const status = +res.status
        if (status === 1) {
          // success
          success && success(res.data)
          if(fromPage=='manageCenter'){
	          localStorage.setItem('agreementSuccessflag', 1)

          }

        } else if (status === 2) {
          // fail
          Toast('识别失败')
        } else if (status === 3) {
          // cancel
          Toast('识别失败')
        }
      }
    )
  } catch (err) {
    console.log(err)
  }
}

export async function finishFacePlus(token, appCallbackData, fromPage) {
  console.log(fromPage,'s======fromPage');
	const params = {
		// verifyData: appCallbackData,
		verifyToken: token
	}
	const res = await api.facepluscb(params)
	if (!res.data) return
  if(res && res.data){
    Toast({
      message: '人脸识别成功',
      duration: 2000
    })
    setTimeout(()=>{
    	if (fromPage === 'manageCenter') {
    	  acceptAtion()
    	} else if (fromPage) {
        location.href = `${location.origin}/wholesale-admin/pages/auth/result.html?fromPage=${fromPage}`
      } else {
        location.replace(`${location.origin}/wholesale-admin/pages/realName/realNameResult/index.html`)
      }
    }, 1000)
  }
}

export async function acceptAtion() {
	const {data} = await  api.getCommonAgreement()
	api.acceptCommonAgreement({
		id: data.id,
		version: data.version,
		token: localStorage.getItem(facePlusTokenKey)
	}).then(() => {
		if (Tools.isApp) {
			window.location.href = `shero://nativePage/ManageHome`
		} else {
			location.href = `${location.origin}/wholesale-admin/pages/manageCenter/index.html`
		}
	})
}
export  function gotoTopUp(opt = {}) {
  let { source = 1, accountid, authToken, ggjRedirect = 1, fromPage } = opt
  location.href = `${location.origin}/wholesale-admin/pages/topUp/index.html?fromPage=${fromPage}&source=${source}${accountid ? `&accountid=${accountid}` : ''}${authToken ? `&authToken=${authToken}` : ''}&isHide=1&isStatusbarHide=1&isHeaderFloat=1&noBounces=1&ggjRedirect=${ggjRedirect}`
}
/* eslint-disable */
export function bridgeFun (callback) {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('zebra') > -1) {
    function setupWebViewJavascriptBridge (callback) {
      if (ua.indexOf('android') > -1) {
        if (window.WebViewJavascriptBridge) {
          callback(WebViewJavascriptBridge)
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', function () {
            callback(WebViewJavascriptBridge)
          }, false)
        }
      } else {
        if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge) }
        if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
        window.WVJBCallbacks = [callback]
        var WVJBIframe = document.createElement('iframe')
        WVJBIframe.style.display = 'none'
        WVJBIframe.src = 'ggjBridge://__BRIDGE_LOADED__'
        document.documentElement.appendChild(WVJBIframe)
        setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
      }
    }
    setupWebViewJavascriptBridge(function (bridge) {
      callback && callback()
    })
    console.log('注册成功')
  }
}
export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  if (window.location.search) {
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return (r[2])
  }
  return null
}

export 	function checkLoadImg(url) {
	return new Promise(function(resolve, reject) {
		let ImgObj = new Image();
		ImgObj.src = url;
		ImgObj.onload = function(res) {
			resolve(res);
		}
		ImgObj.onerror = function(err) {
			reject(err)
		}
	})
}
export  function  debounce(func, delay = 1000) {
	let timer = null;

	return function (...args) {
		// 清除之前设置的定时器，取消上一次未执行的操作
		clearTimeout(timer);

		// 设置新的定时器，延迟执行目标函数
		timer = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	}
}

